<script>
import { Article } from '@/api'
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'

export default {
  extends: BaseWidgetForm,
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.ForeignKey({
              service: Article,
              label: 'Artykuły',
              modelPath: [this, 'form', 'articles'],
              multiple: true,
              sortable: true,
              labelField: 'title_en',
              required: true
            })
          ]
        }
      ]
    }
  }
}
</script>
